<template>
<b-container fluid class="container">



<!-- Excepción -->
  <div v-if="this.noDatos == true " class="row justify-content-center">

              <div class="row justify-content-center ">
                <div class="col-sm-9 text-center mb-2">
                  <p>Esta unidad no esta disponible para calcular una suscripción.</p>
                  <p>Puedes contactarnos a <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> 800-022-5425</p>
                  <div>
                     <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                  </div>

                </div>
              </div>
  </div>

<!--Botones Largas Usados-->
<div v-if="this.noDatos == false" class="row justify-content-center">
  <div class="row justify-content-center">
          <div class="col-sm-9 text-center">
            <h1>Selecciona el período que necesitas.</h1>
            <p>Elige una de las opciones.</p>
          </div>
  </div>

    <div class="col-sm-3 text-center">
    <b-col>
          <b-form-group id="input-group-11" label-for="input-11">
              <h6 class="mb-4">Lugar de entrega del auto</h6>
              <p style="font-size: 18px; color: #51555C; font-weight: 400;font-family: 'Open Sans';font-style: normal;">Domicilio</p>
          </b-form-group>
      </b-col>
    </div>

    <div class="col-sm-3">
    <b-col>
          <b-form-group id="input-group-11" label-for="input-11">
              <h6>Selecciona el estado de emplacamiento</h6>
                  <b-form-select id="input-11" v-model="estado" :options="estados" class="mb-2 select"></b-form-select>
          </b-form-group>
      </b-col>
    </div>

    <div class="col-sm-12 text-center">
      <p style="font-size: 11px; color: grey;">** Los servicios se realizarán en las entidades de emplacamiento y al término del plazo se devuelve en distribuidor.</p>
        <h6 class="mt-4 mb-4 h6TI" >Selecciona la mensualidad</h6>
      <b-row class="justify-content-md-center">
        <b-col> <b-button @click.prevent="mesesDos()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>12 Meses</b> <br> Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial) }}</b> <br> Suscripción mensual <b>${{this.formatPrice(calcula12())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesOcho()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>18 Meses</b> <br> Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial18) }}</b> <br> Suscripción mensual  <b >${{this.formatPrice(calcula18())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesCuatro()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>24 Meses</b> <br>  Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial24) }}</b> <br> Suscripción mensual <b class="ml-1">${{this.formatPrice(calcula24())}}</b></p></b-button></b-col>
      </b-row>
    </div>
    <div class="col-sm-12 text-center">
      <p class="personaM"> Si eres persona moral, llena el formulario en el siguiente enlace.</p>
      <b-row class="justify-content-md-center">
        <b-col><b-button @click.prevent="encuesta()" class="button_s1"><b>Soy persona moral</b></b-button></b-col>
      </b-row>
    </div>

</div>

</b-container>
</template>

<script>

export default {
  name: 'Autocom',
    data() {
    return {
      estado: 'DF',
      entrega: 'Domicilio',
      altaPlacas: 0,

      //Largas
      noDatos: false,

      mileages:'',
      fullmodel: '',
      precioLista: '',
      precioSeguro: '',
      puntos: '',

      //fix:22.90,
      //fix:25.90,
      fix: 23.50,

      // accesories: 1219,
      //Valores GPS
      accesories12: 5822.04,
      accesories18: 8246.44,
      accesories24: 8246.44,
      accesories36: 10670.84,
      accesories48: 13095.24,

      //porcentaje: 0.15
      porcentaje: 0,
      //plates: 43.92,
      plates: 131.75,

      //gastos de investigación 1392 (precio con iva) / 1.16 = 116
      ginvestigacion: 0,

      //12m
      residual1: '',
      mc12: '',
      kms12: 20000,

      //18m
      residual2: '',
      mc18: '',
      kms18: 30000,

      //24m
      residual3: '',
      mc24: '',
      kms24: 40000,

      //Tipos Suscripciones
      suscripcionInicial: '',
      suscripcionInicial18: '',
      suscripcionInicial24: '',

      vDepreciado: '',
      mcDepreciado: '',

      contents: null,
      autos: [],
      photos: [],
      vin: this.$route.query.vin,
      type: this.$route.query.type,
      timeout: null,
      estados: [
      { value: 'DF', text: 'CDMX / Edo. de Mex' },
        { value: 'QT', text: 'Querétaro' },
        { value: 'MN', text: 'Michoacán' },
        { value: 'GT', text: 'Guanajuato' }
      ],
      entregas: [
        { value: 'Domicilio', text: 'Domicilio' },
        { value: 'Trabajo', text: 'Trabajo' },
        { value: 'Distribuidor', text: 'Distribuidor' }
      ],      };
  },

  methods: {

    clearTimeout() {
        if (this.timeout) {
          clearTimeout(this.timeout)
          this.timeout = null
        }
    },

    setTimeout(callback) {
        this.clearTimeout()
        this.timeout = setTimeout(() => {
          this.clearTimeout()
          callback()
        }, 5000);
    },

    regresar(){
      window.history.go(-1);
    },

    encuesta(){
      window.open("https://www.clikautomobility.com/landing-suscripcion-persona-moral");
    },
    cargarInfoVehiculo(){
              axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            }).then((response) => {
              this.estatusU = response.data.usedstock.length;
               //console.log('Estatus LU-->',this.estatusU)
                    sessionStorage.setItem("TipoSuscripcion", 2);
                  sessionStorage.setItem("status", 'used');
                    this.precioaa = response.data.usedstock[0].suscriptionDetails.precioAa;
                    this.precioLista = response.data.usedstock[0].webPrice;
                    this.brand = response.data.usedstock[0].brandDescription;
                    this.model = response.data.usedstock[0].modelDescription;
                    this.mileages = response.data.usedstock[0].mileage.toString();
                    //this.mileages = (45999).toString();
                    this.kmsUsed = response.data.usedstock[0].mileage;
                    sessionStorage.setItem("kms", this.kmsUsed);
                    this.dealerShip = response.data.usedstock[0].dealerShip;
                    sessionStorage.setItem("dealerShip", this.dealerShip);
                    this.fullmodel = this.brand + ' ' + this.model;
                    this.year = response.data.usedstock[0].modelYear;
                    this.calcularKms();
                    this.calcularMeses();
                    this.obtenerModelo();
            }).catch(error => {
            this.noDatos = true;
            console.log('No se pudo obtener info en Cube');
            console.log(error);
        });
    },

    calcularMeses(){
      let today = new Date();
      let anio = today.getFullYear();

      //console.log('Calcular los meses ',anio);

      if(this.year == anio){
         this.mesInicio = 6;
      }
      else {
          this.mesInicio = ((anio-this.year)*12);
          //console.log('mes inicio ',this.mesInicio);
      }
    },

    calcularKms(){
    if (this.mileages.length < 5){
        //console.log('miles',this.mileages.substring(0,4));
        this.calculaMiles();
    } else if (this.mileages.length == 5){
        //console.log('10 miles',this.mileages.substring(1,5));
        this.calcula10Miles();
    } else {
        //console.log('100 miles',this.mileages.substring(2,6));
        this.calculaCienMiles();
      }
    },

    calculaMiles(){
        if(this.mileages.substring(0,4) >= 5000){
            this.kmsRedondeo = 10000;
            //console.log('Redondeo',this.kmsRedondeo);
        } else if(this.mileages.substring(1,4) <= 4999){
            this.kmsRedondeo = 10000;
            //console.log('Redondeo',this.kmsRedondeo);
        }
    },
    calcula10Miles(){
        if(this.mileages.substring(1,5) >= 5000){
            this.kmsRedondeo = ((this.mileages.substring(0,1)*10000)+10000);
            //console.log('Redondeo',this.kmsRedondeo);
        } else if(this.mileages.substring(2,5) <= 4999){
            this.kmsRedondeo = (this.mileages.substring(0,1)*10000);
            //console.log('Redondeo',this.kmsRedondeo);
        }
    },

    calculaCienMiles(){
        if(this.mileages.substring(2,6) >= 5000){
            this.kmsRedondeo = ((this.mileages.substring(0,2)*10000)+10000);
            //console.log('Redondeo 1',this.kmsRedondeo);
        } else if(this.mileages.substring(2,5) <= 4999){
            this.kmsRedondeo = (this.mileages.substring(0,2)*10000);
            //console.log('Redondeo 1',this.kmsRedondeo);
        }
    },

    obtenerModelo(){
    //  console.log('Obtener Unidad');
    axios.get("https://suscripciones.autocom.mx/api/autosVinU/"+this.vin )
      .then((response) => {
        this.movilVersion = response.data[0].model_description;
        //console.log(this.movilVersion);
        this.infoAutos();
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener el Modelo en Cube');
          console.log(error);
        });
    },

  infoAutos(){
      let info = {
      model: this.movilVersion,
      year: this.year};

    //console.log('Info ',info);
    axios.post("https://suscripciones.autocom.mx/api/autos", info)
      .then((response) => {
        this.contents = response;

              this.precioSeguro = this.contents.data[0].insurance;
              //this.precioLista = this.contents.data[0].list_price;
              this.puntos =  this.contents.data[0].points;
              this.depreciado();
              this.variables12();
              this.variables18();
              this.variables24();

        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener Seguro / Puntos Versión -> ',this.movilVersion);
          console.log(error);
        });
    },
   variables12(){
      let info12 = {
      // kms: this.kms12+this.kmsRedondeo,
      // months: 12+this.mesInicio
      kms: 20000,
      months: 12
    };

    //console.log('Info RV -->',info12);
    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info12)
    .then((response) => {
        this.contents = response;
              this.residual1 = this.contents.data[0].pondera;
              this.mc12 = this.contents.data[0].mantto;
              //console.log('Valores 12 -->', this.residual1 +' MC-->',this.mc12);
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener RV / MC Modelo -> ',this.fullmodel);
          console.log(error);
        });
    },

   variables18(){
      let info18 = {
      // description: this.fullmodel,
      // kms: this.kms18+this.kmsRedondeo,
      // months: 18+this.mesInicio
      kms: 30000,
      months: 18
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info18)
    .then((response) => {
        this.contents = response;
              this.residual2 = this.contents.data[0].pondera;
              this.mc18 = this.contents.data[0].mantto;
              //console.log('Valores 18 -->', this.residual3 +' MC-->',this.mc24);
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener RV / MC Modelo -> ',this.fullmodel);
          console.log(error);
        });
    },
   variables24(){
      let info24 = {
      // description: this.fullmodel,
      // kms: this.kms24+this.kmsRedondeo,
      // months: 24+this.mesInicio
      kms: 40000,
      months: 24
    };

    //console.log('Variables 24-->',info24);
    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info24)
    .then((response) => {
        this.contents = response;
              this.residual3 = this.contents.data[0].pondera;
              this.mc24 = this.contents.data[0].mantto;
              //console.log('Valores 24 -->', this.residual3 +' MC-->',this.mc24);
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener RV / MC Modelo -> ',this.fullmodel);
          console.log(error);
        });
    },

    depreciado(){
      let depreciado24 = {
      // description: this.fullmodel,
      kms: this.kmsRedondeo,
      months: this.mesInicio};

    //console.log('info -->',depreciado24);
    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", depreciado24)
    .then((response) => {
        this.contents = response;
              // this.vDepreciado = this.contents.data[0].pondera;
              // this.mcDepreciado = this.contents.data[0].mantto;

              this.vDepreciado = 0;
              this.mcDepreciado = 0;


              //console.log('Valores Depreciado -->', this.vDepreciado +' MC-->',this.mcDepreciado);
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener valor depreciado');
          console.log(error);
        });
    },

    valorPlacas(){
      //console.log('valor placas --->' ,this.estado);
      let info = {
      estado: this.estado};

    axios.post("https://suscripciones.autocom.mx/api/costoPlacas", info)
      .then((response) => {

        this.altaPlacas = parseInt(Number(response.data[0].costo));
        //console.log('Alta Placas ->',this.altaPlacas);

        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener Valor de Emplacamiento -> ',this.estado);
          console.log(error);
        });
    },

    calcula12(){
      this.precioList = (this.precioLista/1.16);
      //console.log('Precio Lista -->',this.precioList);
      this.preciosEspecial = (this.precioaa/1.16);
      //console.log('Precio Especial--->',this.preciosEspecial);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      //console.log('Renta Extra Ordinaria -->',this.rentaExtra);
      //console.log('Comisión Apertura -->',this.comisionApert);
      this.vObjetivo = parseFloat(this.residual1);
      // console.log('Depreciado -->',this.vDepreciado);
      // console.log('objetivo-->',this.vObjetivo);

      //Se mueve el valor del residual por un valor fijo 65.00
      //this.valorResidual = (((1-((this.vDepreciado-this.vObjetivo)/100))*100)-20);
      this.valorResidual = 60.00;

      // console.log('V Residual --->',this.valorResidual);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      // console.log('Valor Residual -->',this.valorResidualT);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      //console.log('Valor resta renta extraordinaria ---> ',this.restaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**12)));
      //console.log('Paso 1 -->',this.calcula);
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-12));
      //console.log('Paso 2 -->',this.calcula2);
      this.otro = ((this.fix/100)/12);
      //console.log('Paso 3 -->',this.otro);
      this.otro2 = ((1+(this.fix/100)/12));
      //console.log('Paso 4 -->',this.otro2);
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2);
      this.claculo3 = (this.calcula2/this.otro); 
      //console.log('Paso 5 -->',this.claculo3);
      //console.log('------------------------------------');
      this.total = this.calcula/this.claculo3;
      //console.log('Financial cost --> ',this.total);
      this.accesorios = this.accesories12/this.claculo3;
      //console.log('accesorios -->',this.accesories12);
      //console.log('Final cost accesories --->',this.accesorios);
      this.financia = (this.total+this.accesorios);
      //console.log('Monthly Financie Lease -->',this.financia);
      //console.log('------------------------------------');
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      //console.log('Seguro ...>',this.insurance);

      this.insuranceFinal = (this.insurance/this.claculo3);
      //console.log('Final Cost Insurance ...>',this.insuranceFinal);
      
      //Se mueve el calculo de forma fija en kms (20000) y meses (12)
      //this.mantenimiento = (((this.mc12/100)*(this.kms12+this.kmsRedondeo))/(12+this.mesInicio));
      //this.mantenimiento = (((this.mc12/100)*(20000))/(12));
      this.mantenimiento = ((this.mc12/100)*(20000));
      // console.log('mantenimiento ..>',this.mantenimiento);
      //this.mantenimiento = 744.27;

      //El valor de telematics cambia a 0
      //this.telematics = 203.49;
      this.telematics = 0;

      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*12);
      this.totalPlates = ((this.plates*12)+2400);

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.totalPlates + this.ginvestigacion);
      this.totalServicios = (this.totalPlates + this.altaPlacas + (this.valorEdo*2) + this.mantenimiento + this.ginvestigacion);
      // console.log('Total Total Plates -->', this.totalPlates);
      // console.log('Total Alta Placas -->', this.altaPlacas);
      // console.log('Total Valor Edo -->',this.valorEdo);
      // console.log('Total Mantenimiento -->',this.mantenimiento);
      // console.log('Total Gastos de Investigación -->',this.ginvestigacion);

      // console.log('Total Services -->',this.totalServicios);
      // console.log('------------------------------------');
      this.finalCostService = (this.totalServicios / this.claculo3 );

      //console.log('Total Services Formula -->',this.finalCostService);

      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

      // console.log('Monthly financial lease -->',this.financia);
      // console.log('Monthly service lease -->',this.monthlyServiceLease);
      
      this.resultado12 = (((this.financia + this.monthlyServiceLease)*1.16));
      //console.log('------------------------------------');
      //console.log('Pago Mensual a 12  -->',this.resultado12);

      this.suscripcionInicial = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado12 );

      return this.resultado12;
    },

    calcula18(){
      this.precioList = (this.precioLista/1.16);
      //console.log('Precio Lista -->',this.precioList);
      this.preciosEspecial = (this.precioaa/1.16);
      //console.log('Precio Especial -->',this.preciosEspecial);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      this.vObjetivo = parseFloat(this.residual2);
      // console.log('Depreciado -->',this.vDepreciado);
      // console.log('objetivo-->',this.vObjetivo);


      //this.valorResidual = (((1-((this.vDepreciado-this.vObjetivo)/100))*100)-20);
      this.valorResidual = 50.00;

      // console.log('V Residual --->',this.valorResidual);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      //console.log('Valor Residual -->',this.valorResidualT);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**18)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-18));
      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2);
      this.claculo3 = (this.calcula2/this.otro);
      this.claculo33 = (this.calcula22/this.otro);
      this.total = this.calcula/this.claculo3;
      //console.log('Financial cost --> ',this.total);
      this.accesorios = this.accesories18/this.claculo3;
      //console.log('accesorios -->',this.accesories18);
      this.financia = (this.total+this.accesorios);
      //console.log('Financie Lease -->',this.financia);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      //console.log('Seguro ...>',this.insurance);

      this.insuranceFinal = (this.insurance/this.claculo33);
      //console.log('Final Cost Insurance ...>',this.insuranceFinal);

      //this.mantenimiento = (((this.mc18/100)*(this.kms18+this.kmsRedondeo))/(18+this.mesInicio));
      //this.mantenimiento = (((this.mc18/100)*(30000))/(18));
      this.mantenimiento = ((this.mc18/100)*(30000));
      //console.log('mantenimiento ..>',this.mantenimiento);
      //this.mantenimiento = 744.27;
      
      //this.telematics = 203.49;
      this.telematics = 0;
      
      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*18);
      this.totalPlates = ((this.plates*18)+2400);

      //Operación Tenencia 
      this.costoTenencia = ((18+12)/12);
      this.tenencia = this.valorEdo*this.costoTenencia;

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
      this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);
      //  console.log('Total Total Plates -->', this.totalPlates);
      //  console.log('Total Alta Placas -->', this.altaPlacas);
      //  console.log('Total Valor Edo -->',this.tenencia);
      //  console.log('Total Mantenimiento -->',this.mantenimiento);
      //  console.log('Total Gastos de Investigación -->',this.ginvestigacion);

      //  console.log('Total Services -->',this.totalServicios);
      //  console.log('------------------------------------');
      this.finalCostService = (this.totalServicios / this.claculo3 );

      // console.log('Total Services Formula -->',this.finalCostService);


      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);


      //this.resultado18 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
      this.resultado18 = (((this.financia + this.monthlyServiceLease)*1.16));
      this.suscripcionInicial18 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado18 );

      //console.log('Resultados -->',this.resultado12);
      return this.resultado18;
    },

    calcula24(){
      this.precioList = (this.precioLista/1.16);
      //console.log('Precio Lista -->',this.precioList);
      this.preciosEspecial = (this.precioaa/1.16);
      //console.log('Precio Especial -->',this.preciosEspecial);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      this.vObjetivo = parseFloat(this.residual3);
      // console.log('Depreciado -->',this.vDepreciado);
      // console.log('objetivo-->',this.vObjetivo);

      //this.valorResidual = (((1-((this.vDepreciado-this.vObjetivo)/100))*100)-20);
      this.valorResidual = 59.00;
      // console.log('V Residual --->',this.valorResidual);
      
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      //console.log('Valor Residual -->',this.valorResidualT);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**24)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-24));
      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));
      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2);
      this.claculo3 = (this.calcula2/this.otro);
      this.claculo33 = (this.calcula22/this.otro);
      //console.log('Calculo -->',this.claculo3); 
      this.total = this.calcula/this.claculo3;
      //console.log('Financial cost --> ',this.total);
      this.accesorios = this.accesories24/this.claculo3;
      //console.log('accesorios 24-->',this.accesories24);
      this.financia = (this.total+this.accesorios);
      //console.log('Financie Lease -->',this.financia);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      // console.log('Precio seguro -->',this.precioSeguro);
      // console.log('Seguro ...>',this.insurance);

      this.insuranceFinal = (this.insurance/this.claculo33);
      //console.log('Final Seguro ...>',this.insuranceFinal);

      //this.mantenimiento = (((this.mc24/100)*(this.kms24+this.kmsRedondeo))/(24+this.mesInicio));
      //this.mantenimiento = (((this.mc24/100)*(40000))/(24));
      this.mantenimiento = ((this.mc24/100)*(40000));

      //console.log('mantenimiento ..>',this.mantenimiento);
      //this.mantenimiento = 744.27;

      //this.telematics = 203.49;
      this.telematics = 0;

      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*24);
      this.totalPlates = ((this.plates*24)+2400);

      //Operación Tenencia 
      this.costoTenencia = ((24+12)/12);
      this.tenencia = this.valorEdo*this.costoTenencia;

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
      this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);

      // console.log('Total Total Plates -->', this.totalPlates);
      // console.log('Total Alta Placas -->', this.altaPlacas);
      // console.log('Total Valor Edo -->',this.tenencia);
      // console.log('Total Mantenimiento -->',this.mantenimiento);
      // console.log('Total Gastos de Investigación -->',this.ginvestigacion);

      // console.log('Total Services -->',this.totalServicios);
      // console.log('------------------------------------');
      this.finalCostService = (this.totalServicios / this.claculo3 );

      //console.log('Total Services Formula -->',this.finalCostService);

      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

      // console.log('Monthly financial lease -->',this.financia);
      // console.log('Monthly service lease -->',this.monthlyServiceLease);

      //console.log('tota servicios -->',this.totalServicios);
      //this.resultado24 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
      this.resultado24 = (((this.financia + this.monthlyServiceLease)*1.16));

      // console.log('Resultados -->',this.resultado24);
      this.suscripcionInicial24 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado24 );
      return this.resultado24;
    },

    mesesDos(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado12));
      sessionStorage.setItem("valortotal", this.formatPriceCostos(this.resultado12));
      sessionStorage.setItem("tiempoSuscripcion", '12 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 12);
      this.$router.push({ path: '/formulario'});
    },

    mesesOcho(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado18));
      sessionStorage.setItem("valortotal", this.formatPriceCostos(this.resultado18));
      sessionStorage.setItem("tiempoSuscripcion", '18 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 18);
      this.$router.push({ path: '/formulario'});
    },

    mesesCuatro(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado24));
      sessionStorage.setItem("valortotal", this.formatPriceCostos(this.resultado24));
      sessionStorage.setItem("tiempoSuscripcion", '24 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 24);
      this.$router.push({ path: '/formulario'});
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    calcularEdos(){
     if(this.estado == 'DF'){

      this.valorEdo = (((3/100)*this.precioLista));
      sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
      sessionStorage.setItem("idemplacamiento", 'DF');

      //  if( this.precioLista < 686791.46){
      //     //this.valorEdo = (((1/100)*this.precioaa)/12);
      //     this.valorEdo = (((1/100)*this.precioaa));
      //     sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
      //     sessionStorage.setItem("idemplacamiento", 'DF');
      //  } else {
      //     //this.valorEdo = (((8.7/100)*this.precioaa)/12);
      //     this.valorEdo = (((8.7/100)*this.precioaa));
      //     sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
      //     sessionStorage.setItem("idemplacamiento", 'DF');
      //  }
     } else if(this.estado == 'QT'){
       if( this.precioLista < 476104.33){
          //this.valorEdo = (((3.75/100)*this.precioaa)/12);
          this.valorEdo = (((3.75/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Querétaro');
          sessionStorage.setItem("idemplacamiento", 'QT');
       } else {
          //this.valorEdo = (((10.875/100)*this.precioaa)/12);
          this.valorEdo = (((10.875/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Querétaro');
          sessionStorage.setItem("idemplacamiento", 'QT');
       }
     } else if(this.estado == 'MN'){
       if( this.precioLista < 428768.31){
          //this.valorEdo = (((3/100)*this.precioaa)/12);
          this.valorEdo = (((3/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Michoacán');
          sessionStorage.setItem("idemplacamiento", 'MN');
       } else {
          //this.valorEdo = (((8.7/100)*this.precioaa)/12);
          this.valorEdo = (((8.7/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Michoacán');
          sessionStorage.setItem("idemplacamiento", 'MN');
       }
     } else if(this.estado == 'GT'){
       if( this.precioLista < 580000){
          //this.valorEdo = (((1/100)*this.precioaa)/12);
          this.valorEdo = (((1/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Guanajuato');
          sessionStorage.setItem("idemplacamiento", 'GT');
       } else {
          //this.valorEdo = (((3/100)*this.precioaa)/12);
          this.valorEdo = (((3/100)*this.precioaa));
          sessionStorage.setItem("emplacamiento", 'Guanajuato');
          sessionStorage.setItem("idemplacamiento", 'GT');
       }
     }
    },

  },

  created() {
    this.cargarInfoVehiculo();
   },

}
</script>

<style scoped>


</style>